import { forwardRef, type ButtonHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

interface GlassButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  variant?: 'primary' | 'secondary' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const GlassButton = forwardRef<HTMLButtonElement, GlassButtonProps>(
  (
    { children, variant = 'primary', size = 'md', className, ...props },
    ref
  ) => {
    return (
      <div className="button-wrap">
        <button
          ref={ref}
          className={cn(
            'glass-button',
            {
              'glass-button-primary': variant === 'primary',
              'glass-button-secondary': variant === 'secondary',
              'glass-button-ghost': variant === 'ghost',
              'glass-button-sm': size === 'sm',
              'glass-button-md': size === 'md',
              'glass-button-lg': size === 'lg',
            },
            className
          )}
          {...props}
        >
          <span className="flex items-center justify-center gap-2">
            {children}
          </span>
        </button>
        <div className="button-shadow"></div>
      </div>
    )
  }
)

GlassButton.displayName = 'GlassButton'

export { GlassButton, type GlassButtonProps }
